// Active AI agent card with status chip, mini-stats, telemetry preview, dual action footer.

import { Sparkline } from '../charts/Sparkline.jsx';

const STATUS_TONE = {
  processing: 'blue',
  analyzing: 'blue',
  running: 'sage',
  succeeded: 'sage',
  idle: 'slate',
  needs_review: 'amber',
  error: 'brick',
};

export function AgentCard({ agent, stats = [], sparkline, onRun, onMonitor, busy }) {
  const tone = STATUS_TONE[String(agent.status || 'idle').toLowerCase()] || 'slate';
  return (
    <article className="agent-card">
      <header className="agent-head">
        <div className="agent-icon" aria-hidden>
          ✦
        </div>
        <div className="stack tight" style={{ flex: 1 }}>
          <strong>{agent.name}</strong>
          <span className="muted small">{agent.purpose || agent.description?.slice(0, 80)}</span>
        </div>
        <span className={`chip ${tone} sm`}>
          {tone === 'blue' || tone === 'sage' ? <span className="chip-dot pulse" /> : null}
          {agent.status || 'idle'}
        </span>
      </header>
      <dl className="agent-stats">
        {stats.map((s) => (
          <div key={s.label}>
            <dt>{s.label}</dt>
            <dd className="mono">{s.value}</dd>
          </div>
        ))}
      </dl>
      {sparkline ? (
        <div className="agent-spark">
          <Sparkline values={sparkline} width={240} height={36} tone="blue" />
        </div>
      ) : null}
      <footer className="agent-actions">
        <button
          className="btn primary sm tactile-press"
          onClick={() => onRun && onRun(agent)}
          disabled={busy}
        >
          Start workflow
        </button>
        <button className="btn outline sm" onClick={() => onMonitor && onMonitor(agent)}>
          Monitor logs
        </button>
      </footer>
    </article>
  );
}
